import { Chip } from "components/DesignSystem/Chips/Chips";
import {
  Filter,
  MultiSelectFilter,
} from "components/DesignSystem/Filter/Filter";
import { useGetSupportingDocumentTagsQuery } from "store/apis/documents";

type DocumentsFilterProps = {
  groupId: string;
  tags: string[];
  onTagsChange: (tags: string[]) => void;
};

export const DocumentsFilter = ({
  groupId,
  tags,
  onTagsChange,
}: DocumentsFilterProps) => {
  const { data: tagOptions = [] } = useGetSupportingDocumentTagsQuery(
    { groupId },
    { skip: !groupId }
  );

  const options = tagOptions.map(({ uuid, title, label }) => ({
    value: uuid,
    label: label ?? title,
  }));

  return (
    <Filter.Root
      defaultValue="tag"
      title=""
      capsule={
        tags.length > 0 && (
          <Chip
            onRemove={() => onTagsChange([])}
            isRemovable
            isActive
            filterType="tag"
          >
            {`Tag (${tags.length})`}
          </Chip>
        )
      }
    >
      <Filter.Portal size="small">
        <Filter.List size="small">
          <Filter.ListItem value="tag">Tag</Filter.ListItem>
        </Filter.List>
        <Filter.Body value="tag" block>
          <MultiSelectFilter
            options={options}
            selected={tags}
            onChange={onTagsChange}
            isSelectAll={false}
          />
        </Filter.Body>
      </Filter.Portal>
    </Filter.Root>
  );
};
